import { render, staticRenderFns } from "./AuctionSectionPagination.vue?vue&type=template&id=b5eabc5e&scoped=true"
import script from "./AuctionSectionPagination.vue?vue&type=script&lang=js"
export * from "./AuctionSectionPagination.vue?vue&type=script&lang=js"
import style0 from "./AuctionSectionPagination.vue?vue&type=style&index=0&id=b5eabc5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5eabc5e",
  null
  
)

export default component.exports